import { ChangeDetectorRef, ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { NxDialogService, NxModalRef } from "@aposin/ng-aquila/modal";
import { Store } from '@ngxs/store';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-premium-information',
  templateUrl: './premium-information.component.html',
  styleUrl: './premium-information.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PremiumInformationComponent implements OnInit {
  
  @Input() premiumInfo: any;
  @Input() isApproval: any;
  @Input() isEndorsement;
  @Input() isRTP;
  @Input() isIssuance;
  data: any = {};
  @Input() coverageType;
  @Input() isPackageSelected;
  @Input() viewOnly;
  @Input() viewPolicyDetails :any;
  @Input() productCode;
  @Input() coverageInfo;

  MOTOR_PRODUCT_LIST = ["082100", "082101"]
  ALLRIDER_VEHICLE_USECODE = ["11", "12-02-01", "12", "12-03", "12-02-03"];

  constructor(
    private readonly dialogService: NxDialogService,
    private store: Store,
    private fb: FormBuilder,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    if (this.premiumInfo) {
      this.data = this.premiumInfo;
    } 
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['premiumInfo'] && changes['premiumInfo'].currentValue) {
      this.data = changes['premiumInfo'].currentValue;
      this.cdr.markForCheck();
    }
    
  }

  formatNumberWithCommas(number) {
      const [integerPart, decimalPart] = number.toString().split('.');
      const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return decimalPart ? `${formattedIntegerPart}.${decimalPart}` : formattedIntegerPart;
  }

  showLoading() {
    return this.data.coverCode === '20';
  }

  get isSelectReplacementBMW() {
    if(this.premiumInfo.subCoverList) {
      return this.premiumInfo.subCoverList.some(a => a.subCoverCode === "A203-3");
    }else {
      return false;
    }

  }

  get carReplacementFees() {
    let carReplacementSubCover = this.premiumInfo?.subCoverList?.find(a => a.subCoverCode === "A203-3");
    return carReplacementSubCover?.subcoverFeesList?.[0]?.feeAmt;
  }

  showAllRiderPremium() {
    let vehicleUseCode : any;
    let coverageTypeCode : any;
    
    if(this.isApproval) {
      vehicleUseCode = this.premiumInfo.vehicleUse;
      coverageTypeCode = this.premiumInfo.coverCode;
    }else if(this.viewOnly || this.viewPolicyDetails || this.isEndorsement) {
      vehicleUseCode = this.coverageInfo.vehicleDetails.vehicleUse;
      coverageTypeCode = this.coverageInfo.coverageDetails.coverCode;
    } else {
      vehicleUseCode = this.coverageInfo.coverage.vehicleDetails.vehicleUse;
      coverageTypeCode = this.coverageInfo.coverage.coverageType.coverCode;      
    }

    if (!coverageTypeCode || !vehicleUseCode) return false;

    const isMotorProduct = this.MOTOR_PRODUCT_LIST.includes(this.productCode);
    const isCoverageTypeValid = coverageTypeCode === '20';    
    const isAllRiderVehicleUseValid = this.ALLRIDER_VEHICLE_USECODE.includes(vehicleUseCode);

    return isMotorProduct && isCoverageTypeValid && isAllRiderVehicleUseValid;
  }

}
